/**
 * @package  	Cavalree_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

var lastScrollPos = 0;

if (typeof $ === "undefined") {
  var $ = jQuery;
}

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
detectScrollbarWidth();

document.addEventListener("DOMContentLoaded", function () {
  const selectFields = document.querySelectorAll('select[name="selectStatus"]');

  if (selectFields) {
    let cookieStudentStatus = getCookie("studentStatus");

    if (!cookieStudentStatus) {
      setTimeout(() => {
        document.getElementById("popStatus").classList.add("is-active");
      }, 2000);
    }
  }
});
// END Vanilla JS
const root = document.documentElement;

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function (e) {
  scrollFixHeader(e);

  // Search Icon
  $(document).on(
    "click",
    ".menu__items--item-search button.menu__items--link",
    function (e) {
      var searchContainer = $(this).parent().find(".search-form-container");

      $(searchContainer).toggleClass("is-active");

      // alert("search open");
    }
  );
});

$(window).scroll(function (e) {
  scrollFixHeader(e);
});

function scrollFixHeader(event) {
  var siteHead = $(".site-header").outerHeight();
  var eyebrowHead = $(".site-header--eyebrow").outerHeight();
  var scrollPos = $(document).scrollTop();

  if (scrollPos < lastScrollPos) {
    if (scrollPos == 0) {
      $(".site-header").removeClass("is-fixed");
    }
  } else {
    if (scrollPos >= eyebrowHead) {
      $(".site-header").addClass("is-fixed");

      if ($(window).width() > 1024) {
        $(".site-main").css({
          paddingTop: parseInt(siteHead) + 50 + "px",
        });
      } else {
        $(".site-main").css({
          paddingTop: siteHead,
        });
      }
    }
  }

  lastScrollPos = scrollPos;
}

// END jQuery Ready
function detectScrollbarWidth() {
  /* Detect scrollbar width to properly center full- and wide-width elements */
  let root = document.documentElement;
  var outside = document.createElement("div");
  var inside = document.createElement("div");

  outside.style.width = inside.style.width = "100%";
  outside.style.overflow = "scroll";
  document.body.appendChild(outside).appendChild(inside);

  var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;

  outside.parentNode.removeChild(outside);
  root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function addHeadingNonBreakingSpace() {
  var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

  headings.forEach(function (head, index) {
    let str = head.textContent;
    let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
    let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

    firstSection = firstSection.trim();

    let newStr = firstSection + "\u00a0" + lastSection;

    head.innerHTML = newStr;
  });
}

function getCookie(name) {
  let cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    let cookiePair = cookies[i].split("=");
    if (cookiePair[0] === name) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}
